// import ResetToDefault from '@/assets/icons/reset.svg?react'
// import { Button } from '@/components/base/Button'
import { Checkbox } from '@/components/base/Checkbox'
import { Trans } from '@/components/Trans'
import { usePermissionForm } from '@/pages/teams/permissionQuota/PermissionFormContext'

import { useAclRanges } from '../useAclRanges'

export function RegionPermission() {
  const { form, setForm } = usePermissionForm()
  const { loading, regions } = useAclRanges()

  const selected = new Set(form.regions ?? [])

  const toggle = (v: number) => {
    const next = new Set(selected)
    next.has(v) ? next.delete(v) : next.add(v)
    setForm({ ...form, regions: Array.from(next.values()).sort((a, b) => a - b) })
  }

  // const handleReset = () => {
  //   const fallback = scope === 'member' ? (teamDefaults?.regions ?? []) : []
  //   setForm({ ...form, regions: fallback.slice().sort((a, b) => a - b) })
  // }
  return (
    <div>
      <div className="flex items-center gap-x-2">
        <div className="h-[20px] border-secondary border-solid border-l-4" />
        <span className="h6 text-primary">
          <Trans i18nKey="team.permissionQuota.regionPermission">Region Permission</Trans>
        </span>
        {/* <Button
          type="link"
          className="t-sb text-btn-primary bg-btn-primary/10 w-40 h-8 p-1 text-center flex items-center justify-center gap-x-1"
          onClick={handleReset}
        >
          <Trans i18nKey="member.resetToDefault">
            <ResetToDefault /> Reset to Default
          </Trans>
        </Button> */}
      </div>
      <div className="flex gap-10 py-8">
        {loading && <div className="t-sm text-secondary">Loading regions…</div>}
        {!loading && regions.length === 0 && (
          <div className="t-sm text-secondary">No regions available</div>
        )}
        {!loading &&
          regions.map((opt) => (
            <Checkbox
              key={opt.value}
              checked={selected.has(opt.value)}
              className={[
                'px-3 py-2 rounded-[10px] border border-neutral-200 bg-panel-white',
                'inline-flex items-center gap-2 cursor-pointer select-none',
                'hover:border-primary/40',
              ].join(' ')}
              checkedBgColor="bg-success/100"
              checkedBorderColor="border-success/100"
              checkIconColor="after:border-white"
              onChange={() => toggle(opt.value)}
            >
              <span className="t-sb">{opt.label}</span>
            </Checkbox>
          ))}
      </div>
    </div>
  )
}
